/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ReportBalancesOnFundGroupsAndFundsFundGroupDto
 */
export interface ReportBalancesOnFundGroupsAndFundsFundGroupDto {
  /**
   *
   * @type {string}
   * @memberof ReportBalancesOnFundGroupsAndFundsFundGroupDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ReportBalancesOnFundGroupsAndFundsFundGroupDto
   */
  name: string;
}

export function ReportBalancesOnFundGroupsAndFundsFundGroupDtoFromJSON(
  json: any
): ReportBalancesOnFundGroupsAndFundsFundGroupDto {
  return ReportBalancesOnFundGroupsAndFundsFundGroupDtoFromJSONTyped(json, false);
}

export function ReportBalancesOnFundGroupsAndFundsFundGroupDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ReportBalancesOnFundGroupsAndFundsFundGroupDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function ReportBalancesOnFundGroupsAndFundsFundGroupDtoToJSON(
  value?: ReportBalancesOnFundGroupsAndFundsFundGroupDto | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
  };
}
